import { BillingInvoice } from 'src/generated/graphql'
import { IInvoice } from 'src/pages/settings/billing/Invoices/types'

export const clInvoiceToIInvoice = (invoice: BillingInvoice): IInvoice => ({
  ...invoice,
  id: invoice.id || invoice.date,
})
